<template>
  <form @submit.prevent="submit">
    <base-input-organization
        v-if="!edit && $store.state.userProfile.systemAdmin"
        :resource="organizationList"
        :input-class="{'is-invalid': $v.model.organizationId.id.$error}"
        :value.sync="$v.model.organizationId.id.$model"
        class="az_base_form_gr"
    ></base-input-organization>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t('name') }}</label>
      <input v-model.trim="$v.model.name.$model"
             :class="{'is-invalid': $v.model.name.$error}"
             class="form-control az_base_inp"
             type="text">
    </div>


    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t('codeName') }}</label>
      <input v-model.trim="$v.model.codeName.$model"
             v-uppercase
             :class="{'is-invalid': $v.model.codeName.$error}"
             class="form-control az_base_inp"
             type="text"
      >
    </div>


    <!--		<base-input-project-type-->
    <!--				class="az_base_form_gr"-->
    <!--				v-if="!edit"-->
    <!--				:input-class="{'is-invalid': $v.model.projectType.$error}"-->
    <!--				:value.sync="$v.model.projectType.$model"-->
    <!--		></base-input-project-type>-->

    <label class="az_base_lbl">{{ $t('team') }}</label>
    <base-input-group
        :input-class="{'is-invalid': $v.model.group.id.$error}"
        :resource="groupList"
        :value.sync="$v.model.group.id.$model"
        class="az_base_form_gr"
        external
    ></base-input-group>

    <label class="az_base_lbl">{{ $t('managers') }}</label>

    <base-input-manager
        :input-class="{'is-invalid': $v.model.manager.id.$error}"
        :resource="managerList"
        :value.sync="$v.model.manager.id.$model"
        class="az_base_form_gr"
        external
    ></base-input-manager>

    <div class="az_base_form_gr">
      <label class="az_base_lbl">{{ $t('deadline') }}</label>
      <datepicker
          v-bind="{'disabled-dates': {to: oneDayBack}}"
          v-model.trim="$v.model.deadLine.$model"
          :class="[{'is-invalid': $v.model.deadLine.$error}]"
          bootstrap-styling
          format="d.MM.yyyy"
      ></datepicker>
    </div>

    <button class="btn az_base_btn btn-primary" type="submit">
      <i class="fa fa-save mr-1"></i>
      {{ $t('save') }}
    </button>

  </form>
</template>

<script>
import BaseInputOrganization from '../../../../components/BaseInputOrganization';
import BaseInputGroup from '../../../../components/BaseInputGroup';
import BaseInputManager from '../../../../components/BaseInputManager';
import Datepicker from 'vuejs-datepicker';
import {required} from 'vuelidate/lib/validators';


const notZero = (value) => +value !== 0;
const today = new Date(moment().format('YYYY-MM-DD'));

export default {
  name: 'TheForm',
  components: {
    BaseInputManager,
    BaseInputGroup,
    BaseInputOrganization,
    Datepicker
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      managerList: [],
      groupList: [],
      organizationList: [],
      startDisabledDates: {
        to: today
      },
    };
  },
  validations() {
    let options = {
      model: {
        name: {
          required,
        },
        codeName: {
          required,
        },
        group: {
          id: {
            notZero,
          }
        },
        manager: {
          id: {
            notZero,
          }
        },
        deadLine: {
          required
        }
      }
    };


    if (!this.edit) {
      if (this.$store.state.userProfile.systemAdmin) {
        options.model.organizationId = {
          notZero,
        };
      }
    }

    return options;
  },
  watch: {
    'model.organizationId'(val) {
      if (this.$store.state.userProfile.systemAdmin) {
        if (!this.edit) {
          this.model.group.id = 0;
          this.groupList = [];

          this.organizationList = [];
          this.model.organizationId.id = 0;

          this.model.manager.id = 0;
          this.managerList = [];
        }

        this.getGroupAll(val);
        this.getManagerAll(val);
        this.getOrganizationAll(val)
      }
    }
  },
  mounted() {
    if (!this.$store.state.userProfile.systemAdmin) {
      this.getGroupAll();
      this.getManagerAll();
      this.getOrganizationAll()
    }
  },
  computed: {
    oneDayBack() {
      return new Date(moment().subtract(1, 'd').format())
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('emit:submit');
    },
    getOrganizationAll(){
      this.$api
          .get('organizations')
          .then(response => {
            this.organizationList = response.data.data;
          });
    },
    getGroupAll(organizationId = this.$store.state.userProfile.organizationId) {
      this.$api
          .get('groups', {
            params: {
              organizationId: organizationId,
            }
          })
          .then(response => {
            this.groupList = response.data.data;
          });
    },
    getManagerAll() {
      this.$api
          .get('employees', {
            params: {
              isManager: true
            }
          })
          .then(response => {
            this.managerList = response.data.data;
          });
    },
  }
};
</script>
<style>
.form-control[readonly] {
  background-color: #fbfbff;
}
</style>
